<template>
  <div class="login-wrap">
    <div id="backgroun"></div>
    <div class="ms-login">
      <img
        src="https://gss3.bdstatic.com/7Po3dSag_xI4khGkpoWK1HF6hhy/baike/c0%3Dbaike92%2C5%2C5%2C92%2C30/sign=478021e3f9f2b211f0238d1cabe90e5d/b812c8fcc3cec3fdabbbe0e5d488d43f8694279c.jpg"
        alt
        width="100"
        height="100"
      />
      <div class="title">注 册</div>
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item prop="username">
          <el-input
            placeholder="用户名"
            clearable
            v-model.trim="form.account"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="password"
            placeholder="密码"
            v-model.trim="form.password"
            clearable
            @keyup.enter.native="login"
            @keyup.13="login"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="form.status"
            placeholder="请选择用户状态"
            style="width:100%;"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="confirm">注 册</el-button>
        </div>
        <!-- <p class="reg" @click="jumpeLogin">登 录</p> -->
        <p class="tips">提示 : 注册成功之后需要超级管理员激活</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { register } from "@/api/login";
export default {
  data: function() {
    return {
      form: {
        account: "",
        password: "",
        status: 2,
      },
      options: [
        { value: 1, name: "正常" },
        { value: 2, name: "禁用" },
      ],
    };
  },
  methods: {
    // 确认注册
    confirm() {
      const { account, password } = this.form;
      if (account == "" || password == "") {
        this.$message.error("填写内容不能为空");
      } else if (password.length < 6) {
        this.$message.error("密码至少六位数");
      } else {
        register(this.form).then(() => {
          this.$message.success("注册成功");
          this.$router.go(-1);
        });
      }
    },
    // 返回登录
    jumpeLogin() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
#backgroun {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #242f42;
  background-image: url("http://clubimg.club.vmall.com/data/attachment/forum/201907/16/2206546g14vgeumziio3kv.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
  filter: blur(3px);
}
.title {
  text-align: center;
  color: #444;
  padding: 20px 0;
  font-size: 1.2rem;
  font-weight: bold;
  font-family: inherit;
  letter-spacing: 3px;
}

.ms-login {
  text-align: center;
}
.ms-login img {
  text-align: center;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 40%;
  width: 300px;
  margin: -150px 0 0 -190px;
  padding: 40px;
  border-radius: 5px;
  background: #fff;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
}
.tips {
  font-size: 12px;
  line-height: 30px;
  color: #999;
}

.reg {
  color: #409eff;
  font-size: 0.9rem;
  cursor: pointer;
}
</style>
